import { getElementData, expandBasicData } from "./data_helpers.js";

let basicData = getElementData("#basic_data");
expandBasicData(basicData);

// TODO: remove when no longer needed
window.dbgData = basicData;

export default basicData;
